import { SCENE_INTERACTION } from "../../constants/scene";
import { SOCKET_EVENTS } from "../../socket/Events";
import { tourID } from "../../setScene";
import { findKeyByValue, tourExists } from "../../socket/socketHelper";
import { SCENE_EVENTS } from "../MVC/Model";
import UserSelectorWithButton from "../Users/UserSelectorWithButton";
import { STREAM_NAMES } from "../WebRTC/constants";
import { TourCameraComponent } from "./tour/TourCameraComponent";
import TourShowEmoticonButton from "./tour/TourShowEmoticonButton";
import { generateIconElement, ICON } from "../Icons/Icons";
import {
  CONFIRM_NOTIFICATION_SIZE,
  CONFIRM_NOTIFICATION_THEME,
  CONFIRM_NOTIFICATION_TYPE
} from "../Modals/Notifications/ConfirmNotification";
import { isMobile } from "./helpers/worldHelpers";
import { BottomNavbarCenterMenu } from "../Navbar/BottomNavBarMenu";
import { createPopper } from "@popperjs/core";

export class TourNameSpan {
  static template() {
    return `<span class="tour-mode__tour-name" data-tour-mode-display="1" style="display: none;"></span>`
  }
}

export class TourModeTimer {
  static template() {
    return `<span class="tour-mode__timer" data-tour-mode-display="1" style="display: none;">mm:ss</span>`
  }

  constructor({ model }) {
    this.model = model
    this.timerInterval = null
    this.cancelCountdown = null
    this.$timer = $('.tour-mode__timer')

    this.$timer.data('controller', this)

    this.init();
  }

  init() {
    const $tooltip = $('<div class="tour-mode__timer-tooltip">hehe</div>');

    $('body').append($tooltip);

    // Initialize Popper
    const popper = createPopper(this.$timer[0], $tooltip[0], {
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 24],
          },
        },
      ],
    });

    $tooltip.hide();

    this.$timer.on('mouseenter', () => {
      const tooltipText = this.$timer.data('tooltip');

      if (tooltipText && tooltipText.trim() !== '') {
        $tooltip.text(tooltipText);
        $tooltip.show();
        popper.update();
      }
    })
    this.$timer.on('mouseleave', () => {
      $tooltip.hide();
    })
  }

  startTimer() {
    const tourData = this.model.iAmInTour();
    clearInterval(this.timerInterval)
    this.cancelCountdown?.()
    this.cancelCountdown = null

    if (tourData.configs?.reachLimitAt) {
      this.cancelCountdown = TourModeTimer.startCountdown(
        tourData.configs.reachLimitAt,
        {
          tooltip: `You are currently using the free version. Your tour is limited to ${tourData.configs?.limit} minutes.`,
          onComplete: () => {
            this.$timer.text('00:00')
          },
        }
      ).finish
      return
    }

    const startedAt = tourData.startedAt
    this.timerInterval = setInterval(() => {
      const diff = Date.now() - startedAt
      if (Number.isNaN(diff) || diff < 0) {
        // there is problems with time on the server and the client
        this.$timer.text('mm:ss')
        clearInterval(this.timerInterval)
        return
      }

      const diffInSeconds = Math.floor(diff / 1000)
      const minutes = Math.floor(diffInSeconds / 60)
      const seconds = diffInSeconds % 60

      this.$timer.text([
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
      ].join(':'))
    }, 1000)
  }

  stopTimer() {
    clearInterval(this.timerInterval)
    this.cancelCountdown?.()
    this.cancelCountdown = null
  }

  static startCountdown(endTime, { tooltip, onComplete } = {}) {
    if (tooltip) {
      $('.tour-mode__timer').data('tooltip', tooltip)
    }

    const timerInterval = setInterval(() => {
      const diff = endTime - Date.now()
      if (Number.isNaN(diff) || diff < 0) {
        clearInterval(timerInterval)
        $('.tour-mode__timer').data('tooltip', '')
        onComplete?.()
        return
      }

      const diffInSeconds = Math.floor(diff / 1000)
      const minutes = Math.floor(diffInSeconds / 60)
      const seconds = diffInSeconds % 60

      $('.tour-mode__timer').text([
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
      ].join(':'))
    }, 1000)

    return {
      finish: () => {
        clearInterval(timerInterval)
        $('.tour-mode__timer').data('tooltip', '')
        onComplete?.()
      },
      pause: () => {
        clearInterval(timerInterval)
      }
    }
  }
}

class ControlLayout {
  static get LAYOUT_MODE() {
    return {
      CIRCLE_SM: 'circle.sm',
      CIRCLE_MD: 'circle.md',
      CIRCLE_LG: 'circle.lg',
      CIRCLE_LEADER: 'circle.leader',
      CIRCLE_MOBILE_SM: 'circle.mobile.sm',
      CIRCLE_MOBILE_MD: 'circle.mobile.md',
      CIRCLE_MOBILE_LG: 'circle.mobile.lg',
      CIRCLE_MOBILE_LEADER: 'circle.mobile.leader',
    }
  }

  static getCorrespondingMode(mode) {
    switch (mode) {
      case this.LAYOUT_MODE.CIRCLE_SM:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_SM:
        return isMobile() ? this.LAYOUT_MODE.CIRCLE_MOBILE_SM : this.LAYOUT_MODE.CIRCLE_SM
      case this.LAYOUT_MODE.CIRCLE_MD:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_MD:
        return isMobile() ? this.LAYOUT_MODE.CIRCLE_MOBILE_MD : this.LAYOUT_MODE.CIRCLE_MD
      case this.LAYOUT_MODE.CIRCLE_LG:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_LG:
        return isMobile() ? this.LAYOUT_MODE.CIRCLE_MOBILE_LG : this.LAYOUT_MODE.CIRCLE_LG
      case this.LAYOUT_MODE.CIRCLE_LEADER:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER:
        return isMobile() ? this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER : this.LAYOUT_MODE.CIRCLE_LEADER
    }
    return null
  }

  static getLayoutButtonConfigs(layoutMode) {
    switch (layoutMode) {
      case this.LAYOUT_MODE.CIRCLE_SM:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_SM:
        return {
          mode: layoutMode,
          class: 'tour-mode__layout-menu__circle-sm',
          imgSrc: '/textures/world/btn_camera_circle_sm.svg',
          imgAlt: 'Set camera circle small',
        }
      case this.LAYOUT_MODE.CIRCLE_MD:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_MD:
        return {
          mode: layoutMode,
          class: 'tour-mode__layout-menu__circle-md',
          imgSrc: '/textures/world/btn_camera_circle_md.svg',
          imgAlt: 'Set camera circle medium',
        }
      case this.LAYOUT_MODE.CIRCLE_LG:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_LG:
        return {
          mode: layoutMode,
          class: 'tour-mode__layout-menu__circle-lg',
          imgSrc: '/textures/world/btn_camera_circle_lg.svg',
          imgAlt: 'Set camera circle large',
        }
      case this.LAYOUT_MODE.CIRCLE_LEADER:
      case this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER:
        return {
          mode: layoutMode,
          class: 'tour-mode__layout-menu__circle-leader',
          imgSrc: '/textures/world/btn_camera_circle_leader.svg',
          imgAlt: 'Set camera circle leader mode',
        }
    }

    return null
  }

  static #buttonTemplate() {
    return `
<div class="world-bottom-nav__area__item tour-mode__controls__layout">
  ${ICON.LAYOUT}
</div>    
`
  }

  static #menuTemplate() {
    const modes = isMobile()
      ? [
        this.LAYOUT_MODE.CIRCLE_MOBILE_SM,
        this.LAYOUT_MODE.CIRCLE_MOBILE_MD,
        this.LAYOUT_MODE.CIRCLE_MOBILE_LG,
        this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER,
      ]
      : [
        this.LAYOUT_MODE.CIRCLE_SM,
        this.LAYOUT_MODE.CIRCLE_MD,
        this.LAYOUT_MODE.CIRCLE_LG,
        this.LAYOUT_MODE.CIRCLE_LEADER,
      ]
    const isLeaderMode = (mode) => mode === this.LAYOUT_MODE.CIRCLE_LEADER || mode === this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER
    return `
<div class="tour-mode__top-area">
  <div class="tour-mode__layout-menu" style="display: none;">
    <div class="tour-mode__layout-menu__label">GröSSe</div>
    <ul class="tour-mode__layout-menu__list">
      ${modes.map(m => this.getLayoutButtonConfigs(m)).filter(m => m).map((config) => `
        <li
            class="tour-mode__layout-menu__list__item ${config.class}"
            style="${isLeaderMode(config.mode) ? `display: none;` : ''}"
        >
          <img
            class="tour-mode__layout-menu__list__item__img"
            src="${config.imgSrc}"
            alt="${config.imgAlt}"
          >
          <div class="tour-mode__layout-menu__list__item__tooltip"></div>
        </li>
      `).join('')}
    </ul>
  </div>
</div>    
`
  }

  static template() {
    return `
<div class="is-flex is-relative">
  ${this.#buttonTemplate()}
  ${this.#menuTemplate()}
</div>
`
  }

  static init({ model, socket }) {
    this.#initState({ model, socket })
    this.#setEventListeners({ model, socket })
    this.checkVisibility({ model })
  }

  static #initState({ model }) {
    this.setLayoutMode({ layoutMode: this.LAYOUT_MODE.CIRCLE_SM, model })
  }

  static #setEventListeners({ model, socket }) {
    const $menu = $('.tour-mode__layout-menu');
    const $controlBtn = $('.tour-mode__controls__layout');

    $controlBtn.on('click', () => {
      $menu.toggle()
    })

    // Hide the menu when click outside the menu
    $(document).on('click', (event) => {
      const $target = $(event.target);
      if (
        $menu.is(":visible")
        && !$target.closest('.tour-mode__layout-menu').length
        && !$target.closest('.tour-mode__controls__layout').length
      ) {
        $menu.hide()
      }
    });

    const modes = isMobile()
      ? [
        this.LAYOUT_MODE.CIRCLE_MOBILE_SM,
        this.LAYOUT_MODE.CIRCLE_MOBILE_MD,
        this.LAYOUT_MODE.CIRCLE_MOBILE_LG,
        this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER,
      ]
      : [
        this.LAYOUT_MODE.CIRCLE_SM,
        this.LAYOUT_MODE.CIRCLE_MD,
        this.LAYOUT_MODE.CIRCLE_LG,
        this.LAYOUT_MODE.CIRCLE_LEADER,
      ]
    modes.forEach((layoutMode) => {
      const config = this.getLayoutButtonConfigs(layoutMode)

      $(`.${config.class}`)
        .on('click', (event) => {
          const $target = $(`.${config.class}`)
          if (!$target.hasClass('tour-mode__layout-menu__list__item--disabled')) {
            this.setLayoutMode({ layoutMode, model })

            socket.socketTour.onEditTourData({ layoutMode })
          }
        })
    })

    model.addEventListener(SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA, (e) => {
      const tour = model.iAmInTour()
      if (!tour) {
        return
      }
      this.setLayoutMode({ layoutMode: tour.layoutMode, model })
    })
  }

  static handleTourStreamerUpdate({ model, tourGuests }) {
    const numOfGuests = Object.keys(tourGuests).length;
    const isLargeModeDisabled = numOfGuests > 1
    const isLeaderModeDisabled = numOfGuests === 0 || numOfGuests > 1

    const currentLayoutMode = $('.tour-mode__media').attr('data-layout-mode')
    const isLargeModeOn = [this.LAYOUT_MODE.CIRCLE_LG, this.LAYOUT_MODE.CIRCLE_MOBILE_LG].includes(currentLayoutMode)
    const isLeaderModeOn = [this.LAYOUT_MODE.CIRCLE_LEADER, this.LAYOUT_MODE.CIRCLE_MOBILE_LEADER].includes(currentLayoutMode)

    if ((isLargeModeDisabled && isLargeModeOn)
      || (isLeaderModeDisabled && isLeaderModeOn)) {
      this.setLayoutMode({ layoutMode: this.LAYOUT_MODE.CIRCLE_MD, model })

      if (model.guidedMode) {
        socket.socketTour.onEditTourData({ layoutMode: this.LAYOUT_MODE.CIRCLE_MD })
      }
    }

    // region following logic only applied for Guide, who has the ability to set layout mode
    if (model.guidedMode) {
      $('.tour-mode__media').toggleClass('tour-mode__media--with-controls', numOfGuests >= 1)

      const $largeModeButton = $('.tour-mode__layout-menu__circle-lg')
      const $leaderModeButton = $('.tour-mode__layout-menu__circle-leader')

      const isShowLeaderMode = numOfGuests >= 1
      if (isShowLeaderMode) {
        $leaderModeButton.show()
      } else {
        $leaderModeButton.hide()
      }

      [$largeModeButton, $leaderModeButton].forEach(($btn) => {
        $btn
          .toggleClass('tour-mode__layout-menu__list__item--disabled', isLargeModeDisabled)
          .find('.tour-mode__layout-menu__list__item__tooltip')
          .text(isLargeModeDisabled ? 'Too many people on the podium to enlarge' : '')
      })
    }
    // endregion
  }

  /**
   * @param layoutMode
   */
  static setLayoutMode({ layoutMode, model }) {
    const correspondingLayoutMode = this.getCorrespondingMode(layoutMode)

    const ACTIVE_CLASS = 'tour-mode__layout-menu__list__item--active'

    $('.tour-mode__layout-menu__list__item').removeClass(ACTIVE_CLASS)

    const config = this.getLayoutButtonConfigs(correspondingLayoutMode)
    if (!correspondingLayoutMode || !config) {
      return
    }

    $(`.${config.class}`).addClass(ACTIVE_CLASS)

    model.dispatchEvent({
      type: SCENE_EVENTS.LAYOUT_MODE_CHANGED,
      data: {
        layoutMode: correspondingLayoutMode,
      }
    })
  }

  static reset() {
    this.#initState()
  }

  static checkVisibility({ model }) {
    const $button = $('.tour-mode__controls__layout')
    const $menu = $('.tour-mode__layout-menu')
    if (model.guidedMode) {
      $button.show()
    } else {
      $button.hide()
      $menu.hide()
    }
  }
}

class ControlMicButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item tour-mode__controls__mic tour-mode__controls__mic--mute">
  ${ICON.MIC_ON}
</div>
<div class="world-bottom-nav__area__item tour-mode__controls__mic tour-mode__controls--unmute" style="display: none;">
  ${ICON.MIC_OFF}
</div>
`
  }
}

class ControlCameraButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item tour-mode__controls__camera tour-mode__controls__camera--off">
  ${ICON.CAMERA_ON}
</div>
<div class="world-bottom-nav__area__item tour-mode__controls__camera--on" style="display: none;">
  ${ICON.CAMERA_OFF}
</div>
`
  }
}

class ControlExitTourModeButton {
  static template() {
    return `
<div class="world-bottom-nav__area__item world-bottom-nav__area__exit tour-mode__controls__exit" title="Exit tour">
  ${ICON.EXIT}
</div>
`
  }
}

export class TourControlBar extends BottomNavbarCenterMenu {
  static selector() {
    return $('.tour-mode__controls')
  }

  static template() {
    return `
<section class="world-bottom-nav__area world-bottom-nav__center_area tour-mode__controls">
  ${ControlLayout.template()}
  ${ControlMicButton.template()}
  ${ControlCameraButton.template()}
  ${TourShowEmoticonButton.template()}
  ${ControlExitTourModeButton.template()}
</section>
`
  }
}

class TourMediaContainer {
  static template() {
    return `<div class='tour_people_top tour-mode__media' data-tour-mode-display="1" style="display: none;"></div>`
  }

  static init({ model }) {
    const initLayoutMode = isMobile() ? ControlLayout.LAYOUT_MODE.CIRCLE_MOBILE_SM : ControlLayout.LAYOUT_MODE.CIRCLE_SM
    $('.tour-mode__media')
      .attr('data-layout-mode', initLayoutMode)
      .data('layoutMode', initLayoutMode)

    model.addEventListener(SCENE_EVENTS.LAYOUT_MODE_CHANGED, (e) => {
      const { layoutMode } = e.data

      $('.tour-mode__media')
        .attr('data-layout-mode', layoutMode)
        .data('layoutMode', layoutMode)
        .toggleClass('tour-mode__media--with-controls', model.guidedMode && $('.tour-camera-wrapper').length > 1)

      this.reArrangeMedia()
    })


    if (!window.tourMediaArrangeInterval) {
      window.tourMediaArrangeInterval = setInterval(() => {
        this.reArrangeMedia()

        $('.tour-mode__media')
          .toggleClass('tour-mode__media--with-controls', model.guidedMode && $('.tour-camera-wrapper').length > 1)
      }, 2000)
    }
  }

  static reArrangeMedia() {
    const $wrapper = $('.tour-mode__media:visible')
    if (!$wrapper.length) {
      return
    }

    const $videoMask = $wrapper.find('.tour-camera-wrapper .tour-camera-container > .mask')
    const $avatar = $wrapper.find('.tour-mode__media__avatar')
    const $micTest = $wrapper.find('.welcome-check-micTest')

    const layoutMode = $wrapper.data('layoutMode') || ''

    const resetUI = () => {
      $wrapper.css('width', '')
      $videoMask.css({
        width: '',
        height: '',
      })

      $avatar.css({
        width: '',
        height: '',
      })

      $micTest.css({
        width: '',
        height: '',
      })
    }

    let gap, videoSize, micTestSize
    switch (layoutMode) {
      case ControlLayout.LAYOUT_MODE.CIRCLE_MOBILE_SM:
        gap = 12; videoSize = 80; micTestSize = 80
        break
      case ControlLayout.LAYOUT_MODE.CIRCLE_SM:
      case ControlLayout.LAYOUT_MODE.CIRCLE_MOBILE_MD:
        gap = 12; videoSize = 120; micTestSize = 120
        break
      case ControlLayout.LAYOUT_MODE.CIRCLE_MD:
      case ControlLayout.LAYOUT_MODE.CIRCLE_MOBILE_LG:
        gap = 12; videoSize = 240; micTestSize = 240
        break
      case ControlLayout.LAYOUT_MODE.CIRCLE_LG:
        gap = 32; videoSize = 480; micTestSize = 480
        break
      case ControlLayout.LAYOUT_MODE.CIRCLE_LEADER:
      case ControlLayout.LAYOUT_MODE.CIRCLE_MOBILE_LEADER:
      default:
        resetUI()
        return
    }

    // Default values
    const numVideos = $videoMask.length
    if (!numVideos) {
      return
    }

    const totalVideoWidth = numVideos * videoSize + (numVideos - 1) * gap
    const windowWidth = $(window).width()

    // Set wrapper width
    const wrapperWidth = Math.min(totalVideoWidth, windowWidth)

    if (wrapperWidth >= totalVideoWidth) {
      // Enough space for all videos
      resetUI()
    } else {
      // Not enough spaces, force smaller size
      const padding = gap * 2
      const forcedVideoSize = (wrapperWidth - (numVideos - 1) * gap - padding) / numVideos
      const sizeDifference = videoSize - forcedVideoSize
      const adjustedMicTestSize = micTestSize - sizeDifference

      $wrapper.css('width', `${wrapperWidth}px`)

      $videoMask.css({
        width: `${forcedVideoSize}px`,
        height: `${forcedVideoSize}px`,
      })

      $avatar.css({
        width: `${forcedVideoSize}px`,
        height: `${forcedVideoSize}px`,
      })

      $micTest.css({
        width: `${adjustedMicTestSize}px`,
        height: `${adjustedMicTestSize}px`,
      })
    }
  }
}

export default class TourModeWindow {
  constructor({ model, socket, controller }) {
    this.model = model;
    this.socket = socket;
    this.controller = controller;
    this.tourGuests = {};
    this.podiumGhosts = new Map();
    this.podiumDeclineTimers = new Map();
    this.podiumLeaveTimers = new Map();

    this.userWantsGuideToMute = false;
    this.userWantsGuideWithNoCamera = false;

    this.wrapper = $(TourControlBar.template());
    TourControlBar.attach(this.wrapper)
    // this.wrapper = $(tour_people_wrapper);
    this.tourTitle = this.wrapper.find(".tour_people_title span").add($('.tour-mode__tour-name'));

    this.videoContainer = $(TourMediaContainer.template());
    $(document.body).append(this.videoContainer);
    TourMediaContainer.init({ model });

    this.guideCamera = new TourCameraComponent({ model, socket, controller, container: this.videoContainer, guide: true });

    this.tourTimer = new TourModeTimer({ model })

    ControlLayout.init({ model, socket })

    this.tourShowEmoticonButton = new TourShowEmoticonButton({ model, socket });
    // if (actions.startTour) {
    this.userSelector;
    // }

    this.upperWrapper = this.wrapper.find('.tour-upper-wrapper');
    this.ctaMenuWrapper = this.wrapper.find('.tour-cta-menu');
    this.ctaMenuVisitorWrapper = this.wrapper.find('#tour-cta-menu-visitor');
    this.ctaMenuVisitorWrapper.hide();

    this.raiseHandButton = this.wrapper.find('#raise_tour_hand');
    this.joinTourButton = this.wrapper.find('#join-tour');
    this.cancelTourButton = this.wrapper.find('#cancel_tour');

    this.muteGuideMicrophoneButton = this.wrapper.find('.tour-mode__controls__mic--mute');
    this.muteGuideMicrophoneButtonOn = this.wrapper.find('.tour-mode__controls--unmute');
    this.muteGuideMicrophoneButtonOn.hide();

    this.muteGuideCameraButton = this.wrapper.find('.tour-mode__controls__camera--off');
    this.muteGuideCameraButtonOn = this.wrapper.find('.tour-mode__controls__camera--on');
    this.muteGuideCameraButtonOn.hide();

    this.tourOptionsButton = this.wrapper.find('#tour-options-button');

    this.raiseHandButton = this.wrapper.find('#tour-raise-hand');
    this.raiseHandButton.hide();

    this.exitTourButton = this.wrapper.find('.tour-mode__controls__exit');

    this.raiseHandButton.on('click', () => {
      this.socket.sendRaiseHand();
    });

    const getMyVideoElements = () => {
      const myVideoWrapper = $('.tour-mode__media__video--local')
      const myMediaWrapper = myVideoWrapper.closest('.tour-camera-wrapper')
      const myAvatarWrapper = myMediaWrapper.find('.tour-mode__media__avatar')
      const mySpeakingIndicator = myMediaWrapper.find('.welcome-check-micTest')

      return {
        myVideoWrapper,
        myMediaWrapper,
        myAvatarWrapper,
        mySpeakingIndicator
      }
    }

    this.muteGuideMicrophoneButton.on('click', () => {
      this.controller.muteLocalMic();
    });
    this.muteGuideMicrophoneButtonOn.on('click', () => {
      this.controller.unmuteLocalMic();
    });

    this.muteGuideCameraButton.on('click', () => {
      this.controller.turnOffLocalCamera();
      this.muteGuideCameraButtonOn.show();
      this.muteGuideCameraButton.hide();

      const { myVideoWrapper, myAvatarWrapper } = getMyVideoElements()

      myVideoWrapper.hide()
      setTimeout(() => {
        myAvatarWrapper.show()
      }, 300)
    });
    this.muteGuideCameraButtonOn.on('click', () => {
      this.controller.turnOnLocalCamera();
      this.muteGuideCameraButtonOn.hide();
      this.muteGuideCameraButton.show();

      const { myVideoWrapper, myAvatarWrapper } = getMyVideoElements()

      myVideoWrapper.show()
      myAvatarWrapper.hide()
    });

    this.tourOptionsButton.on('click', () => {
      this.model.onTourSettings();
    });

    this.exitTourButton.on('click', () => {
      if (this.model.guidedMode || this.model.iAmGuide()) {
        this.confirmEndTour();
        return;
      }
      if (this.amOnPodium()) {
        this.confirmPodiumExitChoice();
        return;
      }
      this.confirmExitTour();
    });

    this.joinTourButton.on('click', () => {
      const tourStarted = this.model.iAmInTour();
      if (!tourStarted) {
        return
      }
      const guide = this.socket.getUserBySocketId(tourStarted.owner);
      if (guide) {
        this.model.onTourStarted();
        this.socket.enableGuidedCamera();
        this.socket.acceptGuideMode(guide.tourName);
      } else {
        this.model.onTourEnded();
      }
    });

    this.joinTourButton.hide();
    this.raiseHandButton.hide();
    this.cancelTourButton.hide();

    this.joinTourButton.on('click', () => {
      const me = socket.getUserData();
      const tourStarted = this.model.iAmInTour();
      if (!tourStarted) {
        return
      }
      const guide = this.socket.getUserBySocketId(tourStarted.owner);
      if (guide) {
        const { currentSceneId } = guide;
        if (me.currentSceneId !== currentSceneId) {
          this.model.nextSceneId = currentSceneId;
          this.model.dispatchEvent({
            type: SCENE_INTERACTION.JUMP_TO_SCENE, data: {
              sceneId: currentSceneId
            }
          });
        }
        this.model.onTourStarted();
      }
    });

    this.cancelTourButton.on('click', () => {
      this.model.onTourEnded();
      this.showAvatar();
    });

    this.raiseHandButton.on('click', () => {
    });

    this.hide();


    this.model.addEventListener(SCENE_EVENTS.LAYOUT_MODE_CHANGED, (e) => {
      const { layoutMode } = e.data

      this.videoContainer.attr('data-layout-mode', layoutMode)
    })

    this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGED, (e) => {
      const { data } = e;

      let videoElId = null
      if (data.tourGuest) {
        videoElId = data.tourGuest
      } else if (data.guide) {
        videoElId = data.guide
      }

      if (videoElId) {
        const $videoEl = $(`#tourVideo-${videoElId}`);
        const $wrapperEl = $videoEl.closest('.tour-camera-wrapper');

        const eventData = {
          audioMuted: data.userAudioMuted,
          videoMuted: data.userVideoMuted,
        }

        $wrapperEl.trigger('mediaStatusUpdated', [eventData])
      }
    })

    this.model.addEventListener(SCENE_INTERACTION.SOCKET_USER_INFO_CHANGE_REQUESTED, (e) => {
      const { data } = e
      const { sender, requestedUser } = data

      if (requestedUser.userId !== this.model.config.userId) {
        return
      }

      if (!this.model.iAmInTour()) {
        return
      }

      const me = this.socket._currentUserData[this.model.config.userId];
      if (me.userAudioMuted !== requestedUser.userAudioMuted) {
        if (requestedUser.userAudioMuted) {
          this.muteGuideMicrophoneButton.click()
          this.model.info('info', `${sender.userName} has muted you.`);
        } else {
          this.muteGuideMicrophoneButtonOn.click()
          this.model.info('info', `${sender.userName} has unmuted you.`);
        }
      }

      if (me.userVideoMuted !== requestedUser.userVideoMuted) {
        if (requestedUser.userVideoMuted) {
          this.muteGuideCameraButton.click()
          this.model.info('info', `${sender.userName} has turn off your camera.`);
        } else {
          this.muteGuideCameraButtonOn.click()
          this.model.info('info', `${sender.userName} has turn on your camera.`);
        }
      }
    })

    this.socket.addEventListener(SOCKET_EVENTS.INIT_USERS, (e) => {
      const actions = socket.getGlobalActions();
      if (this.model.canRunTour() && !this.userSelector) {
        this.userSelector = new UserSelectorWithButton({
          container: this.videoContainer, model: this.model, socket: this.socket
        })
      }
    })
    this.model.addEventListener(SCENE_EVENTS.TOUR_CONTROLLER_INITIALIZED, (e) => {
      this.videoContainer.show();
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_ROOM_JOINED, (e) => {
      this.videoContainer.show();
    });
    this.model.addEventListener(SCENE_EVENTS.TOUR_PUBLISH_STARTED, (e) => {
      this.videoContainer.show();
    });

    this.model.addEventListener(SCENE_INTERACTION.STREAM_RECIEVED, (e) => {
      //guest
      const { data } = e;
      const tourStarted = this.model.iAmInTour();
      if (!tourStarted) {
        return
      }

      const streamId = e.data.streamId;
      const socketId = streamId.replace(STREAM_NAMES.CAMERA_TOUR, "");
      const user = this.socket._currentUserData[socketId];

      if (user && this.tourGuests[streamId]) {
        this.tourGuests[streamId].setGuestTitle(user.userName);
      }

      if (!this.tourGuests[streamId]) {
        const tourCameraComponent = new TourCameraComponent({ model, socket, controller, container: this.videoContainer, data, user });
        this.tourGuests[streamId] = tourCameraComponent;
        tourCameraComponent.streamId = streamId;
        if (user) {
          tourCameraComponent.setGuestTitle(user.userName);
        }
      }

      ControlLayout.handleTourStreamerUpdate({ model, tourGuests: this.tourGuests });
      this.syncPodiumGhosts();
    });

    this.model.addEventListener(SCENE_INTERACTION.STREAM_GUIDE_RECIEVED, async (e) => {
      const tourStarted = this.model.iAmInTour();
      if (!tourStarted) {
        return
      }

      this.tourTitle.html(`${tourStarted.name}`);
      this.tourTimer.startTimer(tourStarted);
      ControlLayout.checkVisibility({ model })

      const { data } = e;
      this.guideCamera.showVideo(data);
      this.guideCamera.streamId = data.streamId;
    });

    this.model.addEventListener(SCENE_EVENTS.GUIDED_MODE_START, (e) => {
      const { data } = e;
      const tourStarted = this.model.iAmInTour();
      this.tourTitle.html(`${tourStarted.name}`)
      this.tourTimer.startTimer(tourStarted)
      ControlLayout.checkVisibility({ model })

      // remove muted status
      this.controller.unmuteLocalMic();
      this.controller.turnOnLocalCamera();
    });
    this.model.addEventListener(SCENE_INTERACTION.KILL_GUEST_MODE_SOCKET_REQUEST, (e) => {
      if (this.tourGuests["me"]) {
        this.tourGuests["me"].stop();
        delete this.tourGuests["me"];
      }
    });
    this.model.addEventListener(SCENE_EVENTS.ON_TOUR_GUEST_ACCEPTED, (e) => {
      ControlLayout.handleTourStreamerUpdate({ model, tourGuests: this.tourGuests });

      const me = this.socket._currentUserData[this.model.config.userId];
      const stream = $("#myTourVideo")[0].srcObject;
      const data = {
        stream,
        title: "Guest: " + me.userName,
      }
      if (!this.tourGuests["me"]) {
        this.tourGuests["me"] = new TourCameraComponent({ model, socket, controller, container: this.videoContainer, data, text: me.userName, user: me });
        this.tourGuests["me"].setVideoMuted();
      } else {
        this.tourGuests["me"].showVideo()
        this.tourGuests["me"].setVideoMuted();
      }

      // remove muted status
      this.controller.unmuteLocalMic();
      this.controller.turnOnLocalCamera();

      this.UIhandleTourMode();
      this.syncPodiumGhosts();
    });
    this.model.addEventListener(SCENE_INTERACTION.TOUR_MODE_STARTED_PUBLISHING, async (e) => {
      ControlLayout.handleTourStreamerUpdate({ model, tourGuests: this.tourGuests });
      const me = this.socket._currentUserData[this.model.config.userId];
      const tourStarted = this.model.iAmInTour();
      const stream = $("#myTourVideo")[0].srcObject;
      const data = {
        title: "Guide: " + "userWhoIsStreaming.userName",
        stream: stream,
      }
      if (tourStarted) {
        if (this.model.iAmGuide()) {
          this.guideCamera.user = me
          this.guideCamera.showVideo(data);
          this.guideCamera.setGuideTitle(me.userName)
          this.guideCamera.setVideoMuted();

        } else {

          if (this.tourGuests["me"]) {
            this.tourGuests["me"].showVideo(data)
            this.tourGuests["me"].setGuestTitle(me.userName)
            this.tourGuests["me"].setVideoMuted();
            return;
          }
        }
      }
      const socketOfIdUserWhoIsStreaming = findKeyByValue(tourStarted.streams, e.data.publishStreamId);
      const userWhoIsStreaming = this.socket.getUserBySocketId(socketOfIdUserWhoIsStreaming);
    });


    this.model.addEventListener(SCENE_INTERACTION.STREAM_REMOVED, async (e) => {
      const { data } = e;
      if (this.tourGuests[data.streamId]) {
        this.tourGuests[data.streamId].stop();
        delete this.tourGuests[data.streamId];
      }
      ControlLayout.handleTourStreamerUpdate({ model, tourGuests: this.tourGuests });
      this.syncPodiumGhosts();
    });

    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_ENDED, async (e) => {
      this.guideCamera.stop(false);

      if (this.tourGuests["me"]) {
        this.tourGuests["me"].stop();
        delete this.tourGuests["me"];
      }
      Object.keys(this.tourGuests).forEach(key => {
        this.tourGuests[key].stop();
      })
      this.tourGuests = {};
      this.clearPodiumGhosts();
      this.hide();

      this.tourTimer.stopTimer()
    });
    this.model.addEventListener(SCENE_EVENTS.UPDATE_TOUR_UI_ON_SOCKET_DATA, async (e) => {
      const tourStarted = this.model.iAmInTour();
      if (tourStarted) {
        const raisedHandUsers = tourStarted.raisedHands;
        this.tourTitle.html(`${tourStarted.name}`)
        this.tourTimer.startTimer(tourStarted.id)
        ControlLayout.checkVisibility({ model })
        this.raiseHandButton.removeClass("active");
        const socketId = this.socket.getUserData().socketId;
        if (raisedHandUsers && raisedHandUsers.includes(socketId)) {
          this.raiseHandButton.addClass("active");
        }
      }
      if (tourStarted) {
        this.guideCamera.findUrl();
        Object.values(this.tourGuests).forEach(tourCameraComponents => {
          if (tourCameraComponents.streamID) {
            const socketOfIdUserWhoIsStreaming = findKeyByValue(tourStarted.streams, tourCameraComponents.streamID);
            const userWhoIsStreaming = this.socket.getUserBySocketId(socketOfIdUserWhoIsStreaming);
            userWhoIsStreaming && tourCameraComponents.setGuestTitle(userWhoIsStreaming.userName);
            userWhoIsStreaming && tourCameraComponents.findUrl();
          }
        })
        const owner = this.socket.getUserBySocketId(tourStarted.owner);
        owner && (this.guideCamera.changeAvatarUrl(owner.userAvatarUrl));
        owner && this.guideCamera.setGuideTitle(owner.userName);
      }
      this.syncPodiumGhosts();
    });
    this.model.addEventListener(SCENE_EVENTS.HIDE_CAMERA_COMPONENTS_CONTEXT_MENU, async (e) => {
      this.closeContextWindowsOnCameraComponents();
    });

    ////TOUR MODE CONTRIBUTOR - TEST
    // this.contributoreContainer = $("#tourContributoreContainer");
    // this.contributoreCamera = $("#contributoreCamera");
    // this.contributoreScreenShare = $("#contributoreScreenShare");
    this.model.addEventListener(SCENE_EVENTS.TOUR_MODE_STARTED, (e) => {
      const tourStarted = this.model.tourData[e.data];
      if (!tourStarted) {
        return
      }
      const owner = this.socket.getUserBySocketId(tourStarted.owner);
      if (owner) {
        this.guideCamera.changeAvatarUrl(owner.userAvatarUrl)
        this.guideCamera.setGuideTitle(owner.userName)
        this.guideCamera.user = owner;
      }

      this.tourTimer.startTimer(tourStarted)
      ControlLayout.checkVisibility({ model })
    });
    // $("#contributoreScreenShare").on('click', () => {
    //   this.controller.webRTCAdaptor.switchDesktopCapture(this.controller.publishStreamId);
    // });
    // $("#contributoreCamera").on('click', () => {
    //   this.controller.webRTCAdaptor.switchVideoCameraCapture(this.controller.publishStreamId);
    // });
  }

  syncPodiumGhosts() {
    if (!this.model.iAmGuide() || !this.videoContainer) {
      this.clearPodiumGhosts();
      return;
    }
    const tour = this.model.iAmInTour();
    const invites = this.model.outgoingPodiumInvites;
    if (!tour || !invites) {
      this.clearPodiumGhosts();
      return;
    }

    let waitingForCamera = false;
    [...invites.entries()].forEach(([userId, user]) => {
      const status = this.model.podiumInviteState?.get(userId);
      if (status === 'declined') {
        this.showDeclinedPodiumGhost(userId, user);
        return;
      }
      const $camera = this.findUserCameraContainer(userId, user);
      if (this.cameraContainerOnScreen($camera)) {
        invites.delete(userId);
        this.model.podiumInviteState?.delete(userId);
        this.removePodiumGhost(userId);
        return;
      }
      const accepted = status === 'accepted' || this.inviteeAcceptedPodium(tour, user);
      if (accepted) {
        this.model.podiumInviteState?.set(userId, 'accepted');
      }
      this.ensurePodiumGhost(userId, user);
      this.setPodiumGhostTone(userId, accepted ? 'accepted' : 'pending');
      if ($camera.length) {
        waitingForCamera = true;
      }
    });

    [...this.podiumGhosts.keys()].forEach((userId) => {
      if (!invites.has(userId)) {
        this.removePodiumGhost(userId);
      }
    });

    if (waitingForCamera) {
      this.schedulePodiumGhostSync();
    } else {
      this.podiumGhostWaitFrames = 0;
    }
  }

  inviteeAcceptedPodium(tour, user) {
    const socketId = user?.socketId != null ? String(user.socketId) : '';
    if (!socketId) {
      return false;
    }
    return (Array.isArray(tour.podiumUsers) ? tour.podiumUsers : [])
      .some((id) => String(id) === socketId);
  }

  setPodiumGhostTone(userId, tone) {
    const $ghost = this.podiumGhosts.get(userId);
    if (!$ghost?.length) {
      return;
    }
    $ghost.toggleClass('is-accepted', tone === 'accepted');
    $ghost.toggleClass('is-declined', tone === 'declined');
  }

  showDeclinedPodiumGhost(userId, user) {
    this.ensurePodiumGhost(userId, user);
    this.setPodiumGhostTone(userId, 'declined');
    if (this.podiumDeclineTimers.has(userId)) {
      return;
    }
    const timer = setTimeout(() => {
      this.podiumDeclineTimers.delete(userId);
      this.model.outgoingPodiumInvites?.delete(userId);
      this.model.podiumInviteState?.delete(userId);
      this.removePodiumGhost(userId);
    }, 500);
    this.podiumDeclineTimers.set(userId, timer);
  }

  findUserCameraContainer(userId, user) {
    const id = String(user?.userId ?? userId ?? '');
    if (!id || !this.videoContainer) {
      return $();
    }
    const videoId = `tourVideo-${STREAM_NAMES.CAMERA_TOUR}${id}`;
    return this.videoContainer
      .find('.tour-camera-wrapper')
      .not('.tour-camera-wrapper--podium-ghost')
      .filter((_, el) => $(el).find('video').attr('id') === videoId)
      .find('.tour-camera-container');
  }

  cameraContainerOnScreen($camera) {
    if (!$camera?.length) {
      return false;
    }
    return $camera.toArray().some((node) => {
      const target = node.querySelector('.mask') || node;
      if (!$(target).is(':visible')) {
        return false;
      }
      const rect = target.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });
  }

  schedulePodiumGhostSync() {
    if (this.podiumGhostSyncFrame) {
      return;
    }
    this.podiumGhostWaitFrames = (this.podiumGhostWaitFrames || 0) + 1;
    if (this.podiumGhostWaitFrames > 60) {
      this.podiumGhostWaitFrames = 0;
      return;
    }
    this.podiumGhostSyncFrame = requestAnimationFrame(() => {
      this.podiumGhostSyncFrame = null;
      this.syncPodiumGhosts();
    });
  }

  ensurePodiumGhost(userId, user) {
    const avatarUrl = user?.userAvatarUrl || user?.avatar_image_url || '/textures/defaultAvatar.png';
    const existing = this.podiumGhosts.get(userId);
    if (existing?.length) {
      existing.find('img').attr('src', avatarUrl);
      return;
    }

    const $ghost = $(`
      <div class="tour-camera-wrapper tour-camera-wrapper--podium-ghost is-entering">
        <div class="evo-me">
          <div class="tour-camera-container">
            <div class="mask">
              <img alt="" />
            </div>
          </div>
        </div>
      </div>
    `);
    $ghost.attr('data-podium-ghost', userId);
    $ghost.find('img').attr('src', avatarUrl).attr('alt', user?.userName || '');
    this.videoContainer.show().append($ghost);
    this.podiumGhosts.set(userId, $ghost);
    TourMediaContainer.reArrangeMedia();
  }

  removePodiumGhost(socketId) {
    const key = String(socketId);
    const existing = this.podiumGhosts.get(key);
    if (!existing?.length || existing.hasClass('is-leaving')) {
      return;
    }
    existing.addClass('is-leaving');
    const finish = () => {
      if (!this.podiumGhosts.get(key)) {
        return;
      }
      clearTimeout(this.podiumLeaveTimers.get(key));
      this.podiumLeaveTimers.delete(key);
      existing.remove();
      this.podiumGhosts.delete(key);
      TourMediaContainer.reArrangeMedia();
    };
    const node = existing.get(0);
    const onEnd = (event) => {
      if (event.target !== node || event.animationName !== 'tour-camera-out') {
        return;
      }
      node.removeEventListener('animationend', onEnd);
      finish();
    };
    node.addEventListener('animationend', onEnd);
    this.podiumLeaveTimers.set(key, setTimeout(finish, 360));
  }

  clearPodiumGhosts() {
    if (this.podiumGhostSyncFrame) {
      cancelAnimationFrame(this.podiumGhostSyncFrame);
      this.podiumGhostSyncFrame = null;
    }
    this.podiumGhostWaitFrames = 0;
    this.podiumDeclineTimers.forEach((timer) => clearTimeout(timer));
    this.podiumDeclineTimers.clear();
    this.podiumLeaveTimers.forEach((timer) => clearTimeout(timer));
    this.podiumLeaveTimers.clear();
    this.podiumGhosts.forEach(($ghost) => $ghost.remove());
    this.podiumGhosts.clear();
  }

  amOnPodium() {
    if (this.model.guidedMode || this.model.iAmGuide()) {
      return false;
    }
    if (this.model.isTourGuest) {
      return true;
    }
    const tour = this.model.iAmInTour();
    const socketId = this.socket.getUserData()?.socketId;
    if (!tour || !socketId) {
      return false;
    }
    if (Array.isArray(tour.podiumUsers) && tour.podiumUsers.includes(socketId)) {
      return true;
    }
    if (Array.isArray(tour.guests) && tour.guests.includes(socketId)) {
      return true;
    }
    return !!(tour.streams && tour.streams[socketId]);
  }

  confirmEndTour() {
    this.model.confirm(
      $trans('end-tour-confirm'),
      () => {
        this.controller.leaveRoom();
        this.socket.socketTour.onTourEnd();
        this.model.onToggleGuideMode()
      },
      {
        header: true,
        title: $trans('end-tour-confirm-title'),
        confirmBtnTxt: $trans('end-tour-confirm-btn'),
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.WARNING,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
        xBtn: false,
        logo: false,
      }
    )
  }

  confirmPodiumExitChoice() {
    this.model.confirm(
      $trans('exit-tour-choice', {}, 'Do you want to guest list or exit Tour'),
      () => {
        const tour = this.model.iAmInTour();
        if (!this.model.iAmGuide() && tour) {
          this.model.info('info', `You quit "${tour.name}". You can join anytime.`);
        }
        this.model.onTourEnded();
        this.hide();
      },
      {
        header: true,
        title: $trans('exit-tour', {}, 'Exit tour'),
        confirmBtnTxt: $trans('exit-tour-choice-exit', {}, 'Exit Tour'),
        cancelBtnTxt: $trans('exit-tour-choice-guest', {}, 'Guest list'),
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.WARNING,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
        xBtn: false,
        logo: false,
        dimmerClose: false,
      },
      () => {
        this.socket.socketTour.leavePodium();
      }
    );
  }

  confirmExitTour() {
    this.model.confirm($trans('exit-tour-confirm'), () => {
      const tour = this.model.iAmInTour();
      if (!this.model.iAmGuide() && tour) {
        this.model.info('info', `You quit "${tour.name}". You can join anytime.`);
      }
      this.model.onTourEnded();
      this.hide();
    },
      {
        header: true,
        title: $trans('exit-tour-confirm'),
        confirmBtnTxt: $trans('exit-tour-confirm-btn'),
        modalTheme: CONFIRM_NOTIFICATION_THEME.DARK,
        modalType: CONFIRM_NOTIFICATION_TYPE.WARNING,
        modalSize: CONFIRM_NOTIFICATION_SIZE.SM,
        xBtn: false,
        logo: false,
      }
    )
  }

  setMicrophoneMuted(muted) {
    if (muted) {
      this.muteGuideMicrophoneButtonOn.show();
      this.muteGuideMicrophoneButton.hide();
    } else {
      this.muteGuideMicrophoneButtonOn.hide();
      this.muteGuideMicrophoneButton.show();
    }
    const speakingIndicator = $('.tour-mode__media__video--local')
      .closest('.tour-camera-wrapper')
      .find('.welcome-check-micTest');
    speakingIndicator.toggle(!muted);
  }

  UIhandleTourMode() {
    this.setMicrophoneMuted(!!this.controller.isMicMuted);
    if (this.controller.isCameraOff) {
      this.muteGuideCameraButtonOn.show();
      this.muteGuideCameraButton.hide();
    } else {
      this.muteGuideCameraButton.show();
      this.muteGuideCameraButtonOn.hide();
    }

    if (this.model.tourMode && !this.model.tourContributore && !this.model.guidedMode && !this.model.isTourGuest) {
      this.raiseHandButton.show();
      this.tourOptionsButton.hide();
      this.muteGuideCameraButton.hide();
      this.muteGuideCameraButtonOn.hide();
      this.muteGuideMicrophoneButton.hide();
      this.muteGuideMicrophoneButtonOn.hide();
      this.ctaMenuWrapper.addClass("left");
    }
  }

  showVideo() {
    this.show();
    this.joinTourButton.hide();
    this.cancelTourButton.show();
    this.tourOptionsButton.show();
    // this.guideAvatarImageWrapper.addClass("hidden");
    // this.guideAvatarVideoWrapper.removeClass("hidden");
    this.UIhandleTourMode();

    this.ctaMenuWrapper.show();
    this.ctaMenuVisitorWrapper.hide();
  }
  setDominantSpeaker(tmpStreamId) {
    if (this.guideCamera.streamId === tmpStreamId) {
      this.guideCamera.mask.css('box-shadow', '0px 0px 0px 5px rgb(107 157 16)');
    }
    if (this.tourGuests["me"] && this.tourGuests["me"].streamId === tmpStreamId) {
      this.tourGuests["me"].mask.css('box-shadow', '0px 0px 0px 5px rgb(107 157 16)');
    } if (this.tourGuests[tmpStreamId]) {
      this.tourGuests[tmpStreamId].mask.css('box-shadow', '0px 0px 0px 5px rgb(107 157 16)');
    }
  }

  removeDominantSpeaker(tmpStreamId) {
    if (this.guideCamera.streamId === tmpStreamId) {
      this.guideCamera.mask.css('box-shadow', '0px 0px 0px 5px rgba(255, 255, 255, 0.25)');
    }
    if (this.tourGuests["me"] && this.tourGuests["me"].streamId === tmpStreamId) {
      this.tourGuests["me"].mask.css('box-shadow', '0px 0px 0px 5px rgba(255, 255, 255, 0.25)');
    } if (this.tourGuests[tmpStreamId]) {
      this.tourGuests[tmpStreamId].mask.css('box-shadow', '0px 0px 0px 5px rgba(255, 255, 255, 0.25)');
    }
  }
  showAvatar(url) {
    this.show();
    this.cancelTourButton.hide();
    this.raiseHandButton.hide();
    this.joinTourButton.show();
    this.tourOptionsButton.show();
    // this.guideAvatarImage.attr("src", url);
    // this.guideAvatarVideoWrapper.addClass("hidden");
    // this.guideAvatarImageWrapper.removeClass("hidden");
    this.UIhandleTourMode();

    this.ctaMenuWrapper.hide();
    this.ctaMenuVisitorWrapper.show();
  }

  show() {
    const barHidden = this.videoContainer.css('display') === 'none';
    $(`[data-tour-mode-display="1"]`).show()
    $(`[data-tour-mode-display="0"]`).hide()

    TourControlBar.show()

    this.ctaMenuWrapper.removeClass("left");
    this.ctaMenuWrapper.show();
    if (this.model.tourMode) {
      this.ctaMenuWrapper.addClass("left");
      this.raiseHandButton.show();
      this.muteGuideMicrophoneButton.hide();
      this.muteGuideCameraButton.hide();
      this.joinTourButton.show();
      this.tourOptionsButton.hide();
    }
    const tourStarted = tourExists(tourID, this.model.tourData);
    if (tourStarted) {
      this.tourTitle.html(`${tourStarted.name}`)
    }
    if (barHidden) {
      this.guideCamera?.playEnterAnimation();
      Object.values(this.tourGuests).forEach((camera) => camera.playEnterAnimation?.());
    }
    this.model.dispatchEvent({ type: SCENE_EVENTS.TOUR_MODE_WINDOW_OPENED })
  }
  hide() {
    $(`[data-tour-mode-display="1"]`).hide()
    $(`[data-tour-mode-display="0"]`).show()

    TourControlBar.hide()

    this.raiseHandButton.hide();
    this.wrapper.find("tour_people_top").empty();
    this.model.dispatchEvent({ type: SCENE_EVENTS.TOUR_MODE_WINDOW_CLOSED })
  }
  closeContextWindowsOnCameraComponents() {
    const all = [this.guideCamera, ...Object.values(this.tourGuests)];
    Object.values(all).forEach(tourCameraComponents => {
      tourCameraComponents.hideUI();
    })
  }
}
